import { cloneDeep } from 'lodash';
import {} from '../../mutation-types';
import * as actions from './actions';
import * as getters from './getters';

const mutations = {};

/** @type {IProjectDataState} */
const state = Object.freeze(cloneDeep(globals.config.project));

export default {
    namespaced: true,
    mutations,
    actions,
    getters,
    state,
};
